var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M4 9.69981L0 5.69981L1.4 4.29981L4 6.89981L10.6 0.299805L12 1.69981L4 9.69981Z",
    fill: "#00BF9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChkGreen);
export default __webpack_public_path__ + "static/media/ic_chk_green.5db815d346e702f4243890ed2050ecbb.svg";
export { ForwardRef as ReactComponent };